import Http from "../../http";;

class CityServices {
  static async getAllCity(data) {
    return Http.get('/cityconfig', data);
  }

  static async getAllCityGroupedByBlock(data) {
    return Http.get('/getAllCityConfigsGroupedByBlock', data);
  }


}

export default CityServices;